import React, {
    useState,
    createContext,
    useContext,
    useEffect,
    useRef,
    useCallback,
    useMemo
} from "react";

const Menu = ({ dataTableStructure, onOptionClick, AppContext }) => {

    const [menu, setMenu] = useState([]);
    const [area, setArea] = useState(dataTableStructure.srArea);
    const [totalReviews, setTotalReviews] = useState(0);
    const [selectedParentCategory, setSelectedParentCategory] = useState(null);
    const [selectedCategory, setSelectedCategory] = useState(dataTableStructure.srSection);
    const [collapsedMenuOptions, setCollapsedMenuOptions] = useState([0, 1, 2, 3, 4]);// All menus should appear collapsed


    useEffect(() => {

        let loadMenuURL = dataTableStructure.menuUrl;

        fetch(loadMenuURL)
            .then((response) => {
                if (!response.ok) {
                    if (response.status === 401)
                        document.dispatchEvent(new Event("api:unauthorized"));

                    throw new Error("Network response was not ok");
                }
                return response.json();
            })
            .then((data) => {
                // Update state with the received data
                setMenu(data);

                let totalReviewsCount = data.reduce((ac, cur) => ac + cur.ParentCount, 0);
                setTotalReviews(totalReviewsCount);


                // The page is called with a specific section?
                if (dataTableStructure.srSection) {
                    let found = null;

                    data.forEach(item => {
                        let a = item.ChildCategories.find(item => item.Alias == dataTableStructure.srSection);
	                    if(a)
		                    found = a;
                    })

                    // Change menu to match the pre-selected section
                    if (found) {
                        changeMenuOption(found.ParentCategory, found.Alias);
                    }
                }

            })
            .catch((error) => {
                
            });

        
        


    }, []);



    const changeMenuOption = (parentCategory, category) => {

        if (AppContext.isLoadingData)
            return;

        setSelectedParentCategory(parentCategory);
        setSelectedCategory(category);
        onOptionClick(category);

    }


    const expandMenu = (index) => {

        if (collapsedMenuOptions.includes(index))
            setCollapsedMenuOptions(collapsedMenuOptions.filter(item => item !== index));
        else
            setCollapsedMenuOptions([...collapsedMenuOptions, index]);

    }



    const drawMenu = () => {

        return <>


            {menu.map((menuItem, index) => (

                <div key={index}>

                    <div style={{ textSecoration: "none", color: "#203864", fontWeight: "600" }}>
                        <div className="menu-item-row" style={{ display: "flex", flexDirection: "row", textAlign: "left", padding: "10px 6px 10px 6px", borderRadius: "10px", backgroundColor: selectedParentCategory == menuItem.ParentCategory ? "#eee" : "transparent" }}>
                            <div className="ellipsis" title={menuItem.ParentCategory} style={{ flex: "1 1 0%" }}>
                                <i id="middle-menu-opened-indicator-1" onClick={() => expandMenu(index)} style={{ cursor: "pointer", fontSize: "12pt", color: "rgb(119, 119, 119)", marginRight: "6px", width: "10px" }} className={collapsedMenuOptions.includes(index) ? "fas fa-angle-right" : "fas fa-angle-down" }></i>
                                {menuItem.ParentCategory}
                            </div>
                            <div>
                                <span style={{ fontSize: "9pt", borderRadius: "15px", backgroundColor: "rgb(240, 240, 240)", padding: "0px 9px" }}>{menuItem.ParentCount}</span>
                            </div>
                        </div>
                    </div>


                    <div id={`category_middle_menu_${index}`} className="category_middle_menu" style={{ marginLeft: "25px", display: collapsedMenuOptions.includes(index) ? "none" : "block" }}>

                        <div style={{ width: "100%" }}><hr style={{ borderColor: "rgb(240, 240, 240)", margin: "3px" }} /></div>

                        {menuItem.ChildCategories.map((menuOption, index) => (

                            <div key={index} onClick={() => { changeMenuOption(menuOption.ParentCategory, menuOption.Alias); } } style={{ textDecoration: "none", color: "#333", }}>
                                <div className="menu-item-row " style={{ cursor: "pointer", display: "flex", flexDirection: "row", textAlign: "left", padding: "6px", borderRadius: "10px", backgroundColor: selectedCategory == menuOption.Alias ? "#eee" : "transparent" }}>
                                    <div className="ellipsis" title={menuOption.ItemName} style={{ flex: "1 1 0%" }}>{menuOption.ItemName}</div>
                                    <div>
                                        <span style={{ fontSize: "9pt", borderRadius: "15px", backgroundColor: "rgb(240, 240, 240)", padding: "0px 9px" }}>{menuOption.SystematicReviewCount}</span>
                                    </div>
                                </div>
                            </div>

                        ))}

                    </div>

                </div>    
            )
            )}
        </>

    }


	return <>


        <div className="main_label" style={{ display: "block" }}>
            <div style={{ display: "flex", flexDirection: "row", textAlign: "left", padding: "6px", borderRadius: "10px" }} ><b>SRs Menu</b></div>
        </div>
        <br/>

        <div style={{ width: "100%" }} ><hr style={{ borderColor: "rgb(240, 240, 240)", margin: "3px" }} /></div>

        <div>
            <a href={`/your-medboard/systematic-reviews-menu/?area=${area}`} style={{ textDecoration: "none", color: "#203864", fontSize: "13px" }}>
                <div className="menu-item-row font-weight-bold" style={{ cursor: "pointer", display: "flex", flexDirection: "row", textAlign: "left", padding: "15px 6px 15px 6px", borderRadius: "10px", backgroundColor: selectedCategory == "" ? "#eee" : "transparent" }}>
                    <div className="ellipsis" title="Systematic Reviews (SRs)" style={{ flex: "1 1 0%" }}><span className="fas fa-file-signature g-mr-8 g-font-size-14"></span>
                        {area == 0 ? "All Searches" : "" }
                        {area == 1 ? "Clinical Reviews" : "" }
                        {area == 2 ? "Regulatory Reviews" : "" }
                        {area == 3 ? "Market Reviews" : "" }
                        {area == 4 ? "PMS Vigilance Reviews" : "" }
                    </div>
                    <div>
                        <span style={{ fontSize: "9pt", borderRadius: "15px", backgroundColor: "rgb(240, 240, 240)", padding: "0px 9px" }}>{totalReviews}</span>
                    </div>
                </div>
            </a>
        </div>



        {drawMenu()}

        {/* HIDE SR GROUPS FROM MENU */}
        <div style={{ display: "none" }}>

            <div style={{ width: "100%" }}><hr style={{ borderColor: "rgb(240, 240, 240)", margin: "3px" }} /></div>

            <div>
                <a href="/your-medboard/srs-groups/" style={{ textDecoration: "none", color: "#203864", fontSize: "13px" }}>
                    <div className="menu-item-row font-weight-bold" style={{ cursor: "pointer", display: "flex", flexDirection: "row", textAlign: "left", padding: "15px 6px 15px 6px", borderRadius: "10px" }}>
                        <div className="ellipsis" title="All Systematic Reviews Groups" style={{ flex: "1 1 0%" }}><span className="fas fa-layer-group g-mr-8 g-font-size-14"></span>SRs Groups</div>
                        <div>
                            <span style={{ fontSize: "9pt", borderRadius: "15px", backgroundColor: "rgb(240, 240, 240)", padding: "0px 9px" }}>{dataTableStructure.surveillanceGroupsNr}</span>
                        </div>
                    </div>
                </a>
            </div>
        </div>

	</>

}


export default Menu;